export const BOOLVALUEINT = [
    { Name: "Nej", Value: 0 },
    { Name: "Ja", Value: 1 },
];